import {createWorker} from '../lib/worker-api/create-worker';

createWorker(async (data) => {
  // @ts-ignore
  return data;
});
